import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { ThemeOptions, useTheme } from "../providers/ThemeProvider";
import { useTranslation } from "react-i18next";

const makeStyles = (theme: ThemeOptions) =>
  StyleSheet.create({
    page: {
      backgroundColor: theme.background,
      flex: 1,
      alignItems: "center",
      justifyContent: "center",
    },
    text: {
      color: theme.backgroundText,
    },
  });

export const NotFoundLayout = () => {
  const theme = useTheme();
  const styles = makeStyles(theme);
  const { t } = useTranslation("NotFoundLayout");

  return (
    <View style={styles.page}>
      <Text style={styles.text}>{t("Configuration not found")}</Text>
    </View>
  );
};
